var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.202 9.332 1.462 1.462L4.542 24.885H3.11v-1.43zM22.802 0c-.39 0-.794.156-1.09.451l-2.846 2.846L24.7 9.13l2.846-2.846c.607-.607.607-1.618 0-2.193L23.905.45A1.53 1.53 0 0 0 22.802 0m-5.6 4.962L0 22.164v5.832h5.833l17.202-17.202z"
  })));
};
export default SvgPencil;